export const WAREHOUSES_RESET_STATE = 'WAREHOUSES_RESET_STATE';
export const WAREHOUSES_CURRENT_ITEM = 'WAREHOUSES_CURRENT_ITEM';

export const WAREHOUSES_REQUEST_LOADING = 'WAREHOUSES_REQUEST_LOADING';
export const WAREHOUSES_REQUEST_SUCCESS = 'WAREHOUSES_REQUEST_SUCCESS';
export const WAREHOUSES_REQUEST_FAILED = 'WAREHOUSES_REQUEST_FAILED';

export const WAREHOUSES_CURRENT_ACTION = 'WAREHOUSES_CURRENT_ACTION';
export const WAREHOUSES_RESET_ACTION = 'WAREHOUSES_RESET_ACTION';